// src/constants/audienceOptions.js

export const COUNTRY_OPTIONS = [
  "United States",
  "Canada",
  "United Kingdom",
  "Australia",
  "Germany",
  "France",
  "Spain",
  "Mexico",
  "Brazil",
  "India",
  "Japan",
  "South Korea",
  "Philippines",
  "Indonesia",
  "Vietnam",
  "Singapore",
  "Italy",
  "Netherlands",
  "Sweden",
  "Norway",
  "Denmark",
  "Switzerland",
  "Ireland",
  "Portugal",
  "Other",
];

export const CITY_OPTIONS_BY_COUNTRY = {
  "United States": [
    "New York",
    "Los Angeles",
    "San Francisco",
    "San Jose",
    "Chicago",
    "Miami",
    "Austin",
    "Seattle",
    "Other",
  ],
  Canada: ["Toronto", "Vancouver", "Montreal", "Other"],
  "United Kingdom": ["London", "Manchester", "Birmingham", "Other"],
  Australia: ["Sydney", "Melbourne", "Brisbane", "Other"],
  Germany: ["Berlin", "Munich", "Hamburg", "Frankfurt", "Other"],
  France: ["Paris", "Lyon", "Marseille", "Toulouse", "Other"],
  Spain: ["Madrid", "Barcelona", "Valencia", "Seville", "Other"],
  Mexico: ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Other"],
  Brazil: ["São Paulo", "Rio de Janeiro", "Brasília", "Salvador", "Other"],
  India: ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Other"],
  Japan: ["Tokyo", "Osaka", "Yokohama", "Kyoto", "Other"],
  "South Korea": ["Seoul", "Busan", "Incheon", "Daegu", "Other"],
  Philippines: ["Manila", "Quezon City", "Cebu", "Davao", "Other"],
  Indonesia: ["Jakarta", "Surabaya", "Bandung", "Medan", "Other"],
  Vietnam: ["Ho Chi Minh City", "Hanoi", "Da Nang", "Hai Phong", "Other"],
  Singapore: ["Singapore", "Other"],
  Italy: ["Rome", "Milan", "Naples", "Turin", "Other"],
  Netherlands: ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Other"],
  Sweden: ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Other"],
  Norway: ["Oslo", "Bergen", "Trondheim", "Stavanger", "Other"],
  Denmark: ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Other"],
  Switzerland: ["Zurich", "Geneva", "Basel", "Bern", "Other"],
  Ireland: ["Dublin", "Cork", "Limerick", "Galway", "Other"],
  Portugal: ["Lisbon", "Porto", "Coimbra", "Braga", "Other"],
};

export const LANGUAGE_OPTIONS = [
  "English",
  "Spanish",
  "Portuguese",
  "French",
  "German",
  "Italian",
  "Dutch",
  "Chinese (Mandarin)",
  "Cantonese",
  "Japanese",
  "Korean",
  "Vietnamese",
  "Tagalog",
  "Hindi",
  "Arabic",
  "Other",
];




